import React from 'react'
import { exportToExcel } from '../../helper/exportToExcel'
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import ExcelJS from 'exceljs'
const { DateTime } = require("luxon")


const getISTTimestamp = (utcDate) => {
    return DateTime.fromISO(utcDate, { zone: "utc" })
        .setZone("Asia/Kolkata") // convert to IST
        .toFormat("dd/MM/yy HH:mm:ss"); // format
};

function ExportToExcel({ fileName, data, loading }) {
    const exportToExcel = async () => {
        // Create a new workbook and worksheet
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Sheet1');

        // Extract columns from the first row of data 
        if (data.length > 0) {
            const excludeKeys = ['__v', '_id', 'updatedAt', 'createdAt']; // unwanted keys

            // Flatten nested objects (like user) into top-level fields
            const flattenObject = (obj, parentKey = '', res = {}) => {
                for (let [key, value] of Object.entries(obj)) {
                    if (excludeKeys.includes(key)) continue; // skip unwanted keys

                    const newKey = parentKey ? `${parentKey}_${key}` : key;

                    if (value && typeof value === 'object' && !Array.isArray(value)) {
                        // recursively flatten
                        flattenObject(value, newKey, res);
                    } else {
                        res[newKey] = value;
                    }
                }
                return res;
            };


            const flattenedData = data.map(row => {
                const flat = flattenObject(row);
                flat.timestamp = getISTTimestamp(flat.timestamp);
                return flat;
            });

            // Dynamically define columns from flattened data
            const columns = Object.keys(flattenedData[0]).map(key => ({
                header: key.charAt(0).toUpperCase() + key.slice(1),
                key: key,
                width: 20
            }));

            worksheet.columns = columns;

            // Add flattened rows
            flattenedData.forEach(row => worksheet.addRow(row));
        }
        // Generate Excel file as a buffer
        const buffer = await workbook.xlsx.writeBuffer();

        // Create a Blob from the buffer and save the file
        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        saveAs(blob, fileName || 'download.xlsx');
    };
    return (
        <button onClick={exportToExcel} disabled={loading} className='btn' >Export to Excel</button>
    )
}

export default ExportToExcel